const uniqueArray = (arr, { prop, map } = {}) => {
  if (!arr) {
    return [];
  }

  if (prop) {
    if (map) {
      return [...new Set(arr.map(item => item[prop]))];
    }
    return [...new Map(arr.map(item => [item[prop], item])).values()];
  }

  return [...new Set(arr)];
};

module.exports = {
  uniqueArray,
};
